import { Skeleton } from '@mui/material'
import { FC } from 'react'

interface IProps {
  children?: any
  variant?: 'text' | 'rectangular' | 'circular'
  width?: string
  height?: string
  animation?: 'pulse'| 'wave' | false
  sx?: { [key: string]: string }
}

const SkeletonLoader: FC<IProps> = ({ children, variant = 'text', width, height, animation='pulse', sx }) => {
  return (
    <Skeleton variant={variant} width={width} height={height} animation={animation} sx={sx}>
      {children}
    </Skeleton>
  )
}
export default SkeletonLoader
